import { Box, Grid } from '@material-ui/core';
import { Typography } from '@saesa/ui-kit-front';
import { imgLosMejores } from 'assets/images';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { RootState } from 'store';
import Arroba from './Arroba';
import useStyles from './FooterStyles';
import PuntoMapa from './PuntoMapa';
import Redireccion from './Redireccion/Redireccion';
import Telefono from './Telefono';

const Footer = ({ className }: { className: string }) => {
  const styles = useStyles();

  const logo = useSelector((state: RootState) => state.tracking.distribuidora);

  return (
    <footer className={className}>
      <Box paddingX={{ xs: 3, md: 3 }} paddingY={{ xs: 3, md: 9 }} className={styles.contenido}>
        <Grid className={styles.contenedorFooter} container spacing={4}>
          <Grid container item xs={12} md={4}>
            <Grid className={styles.link} item xs={6} md={4}>
              <Link className={styles.logo} to="/">
                <img className={styles.imagen} src={logo.urlLogo} alt="" />
              </Link>
            </Grid>
            <Grid item xs={6} md={6}>
              <Link className={styles.logo} to="/">
                <img className={styles.imagen} src={imgLosMejores} alt="" />
              </Link>
            </Grid>
          </Grid>
          <Grid container item xs={12} md={2} className={styles.linea}>
            <Box width="100%" marginBottom={1}>
              <Typography className={styles.textoLista} variant="h2" strong="bold">
                Distribuidoras
              </Typography>
            </Box>
            <Grid item xs={6} md={12}>
              <Redireccion className={styles.textoLista} texto="Frontel" variant="parrafo" link="https://web.gruposaesa.cl/web/frontel" />
            </Grid>
            <Grid item xs={6} md={12}>
              <Redireccion className={styles.textoLista} texto="Saesa" variant="parrafo" link="https://web.gruposaesa.cl/web/saesa" />
            </Grid>
            <Grid item xs={6} md={12}>
              <Redireccion
                className={styles.textoLista}
                texto="Luz Osorno"
                variant="parrafo"
                link="https://web.gruposaesa.cl/web/luz-osorno"
              />
            </Grid>
            <Grid item xs={6} md={12}>
              <Redireccion
                className={styles.textoLista}
                texto="Edelaysen"
                variant="parrafo"
                link="https://web.gruposaesa.cl/web/edelaysen"
              />
            </Grid>
          </Grid>
          <Grid className={styles.linea} container item xs={12} md={4}>
            <Grid item className={styles.secciones} xs={12}>
              <Box marginBottom={1}>
                <Typography className={`${styles.textoLista} ${styles.seccion}`} variant="h2" strong="bold">
                  Secciones
                </Typography>
              </Box>
            </Grid>
            <Grid container item xs={6}>
              <Grid item xs={12}>
                <Redireccion
                  className={styles.textoLista}
                  texto="Quienes somos"
                  variant="parrafo"
                  link="https://web.gruposaesa.cl/quienes-somos"
                />
              </Grid>
              <Grid item xs={12}>
                <Redireccion
                  className={styles.textoLista}
                  texto="Inversionistas"
                  variant="parrafo"
                  link="https://web.gruposaesa.cl/inversionistas"
                />
              </Grid>
              <Grid item xs={12}>
                <Redireccion
                  className={styles.textoLista}
                  texto="Proveedores"
                  variant="parrafo"
                  link="https://web.gruposaesa.cl/proveedores-y-contratistas"
                />
              </Grid>
              <Grid item xs={12}>
                <Redireccion
                  className={styles.textoLista}
                  texto="Sustentabilidad"
                  variant="parrafo"
                  link="https://web.gruposaesa.cl/sustentabilidad"
                />
              </Grid>
            </Grid>
            <Grid container item xs={6}>
              <Grid item xs={12}>
                <Redireccion
                  className={styles.textoLista}
                  texto="Trabaja con nosotros"
                  variant="parrafo"
                  link="https://web.gruposaesa.cl/personas/trabaja-con-nosotros"
                />
              </Grid>
              <Grid item xs={12}>
                <Redireccion
                  className={styles.textoLista}
                  texto="Red de oficinas"
                  variant="parrafo"
                  link="https://web.gruposaesa.cl/web/saesa/red-de-oficinas"
                />
              </Grid>
              <Grid item xs={12}>
                <Redireccion
                  className={styles.textoLista}
                  texto="Contáctanos"
                  variant="parrafo"
                  link="https://web.gruposaesa.cl/consultas-y-reclamos"
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid container item xs={12} md={2}>
            <Box marginBottom={1}>
              <Typography className={styles.textoLista} variant="h2" strong="bold">
                Ayuda
              </Typography>
            </Box>
            <Grid item xs={12}>
              <Redireccion
                className={styles.textoLista}
                texto="Preguntas Frecuentes"
                variant="parrafo"
                link="https://web.gruposaesa.cl/documentacion/preguntas-frecuentes"
              />
            </Grid>
            <Grid item xs={12}>
              <Redireccion className={styles.textoLista} texto="Glosario" variant="parrafo" link="" />
            </Grid>
            <Grid item xs={12}>
              <Redireccion
                className={styles.textoLista}
                texto="Términos de uso"
                variant="parrafo"
                link="https://web.gruposaesa.cl/documentacion/glosario"
              />
            </Grid>
            <Grid item xs={12}>
              <Redireccion
                className={styles.textoLista}
                texto="Términos de uso"
                variant="parrafo"
                link="https://web.gruposaesa.cl/documents/20121/42825/Terminos-de-Uso-para-sitio-web.pdf/b3b8a8e7-29ff-ea40-6c28-3e50661af8d7?t=1612823333137"
              />
            </Grid>
            <Grid item xs={12}>
              <Redireccion
                className={styles.textoLista}
                texto="Política de privacidad"
                variant="parrafo"
                link="https://web.gruposaesa.cl/documents/20121/42825/Politica-privacidad-y-proteccion-de-datos-personales-para-sitio-web.pdf/16edfa19-54fb-39af-0f36-cc647859d338?t=1612823332473"
              />
            </Grid>
          </Grid>
        </Grid>
      </Box>
      <Grid container item xs={12} className={styles.bottom}>
        <Grid item xs="auto" md={3} />
        <Grid item xs={12} md={2}>
          <Typography className={styles.textoBottom} variant="h2">
            <Arroba className={styles.icono} />
            info@saesa.cl
          </Typography>
        </Grid>
        <Grid item xs={12} md={2}>
          <Typography className={styles.textoBottom} variant="h2">
            <Telefono className={styles.icono} />
            800 600 801
          </Typography>
        </Grid>
        <Grid item xs={12} md={3}>
          <Typography className={styles.textoBottom} variant="h2">
            <PuntoMapa className={styles.icono} />
            Bulnes 441, Osorno, Chile
          </Typography>
        </Grid>
        <Grid />
      </Grid>
    </footer>
  );
};

export default Footer;
